import * as React from 'react'
import { GridColDef } from '@mui/x-data-grid-pro'
import { BulkActionErrorCell } from './BulkActionErrors'
import { BulkActionErrors } from './typings'

export const bulkActionErrors: BulkActionErrors = {
  updateStatus: {
    closed: {
      name: 'Closed Records',
      rowError: 'Record Closed',
      description:
        'The record(s) highlighted in the table will not be included. The sales funnel/status cannot be updated because these records are already closed. Re-open them to make updates.',
    },
    requirements: {
      name: 'Closing Requirements Not Satisfied',
      rowError: 'Closing Requirements Not Satisfied',
      description:
        'The record(s) highlighted in the table will not be included. They cannot be closed/won because they have open closing requirements that have not been satisfied.',
    },
  },
  reopen: {
    closedWon: {
      name: 'Closed/Won Records',
      rowError: 'Record Closed/Won',
      description:
        'Some of the selected records cannot be re-opened because they are closed/won and in completed and/or processing status. ',
    },
    open: {
      name: 'Open Records',
      rowError: 'Record Open',
      description:
        'The record(s) highlighted in the table will not be included. They cannot be re-opened because they are already open.',
    },
  },
  closedWinStatus: {
    closed: {
      name: 'Closed Records',
      rowError: 'Closed Record',
      description:
        'The record(s) highlighted in the table will not be included. The sales funnel/status cannot be updated because these records are already closed. Re-open them to make updates.',
    },
    requirements: {
      name: 'Closing Requirements Not Satisfied',
      rowError: 'Closing Requirements Not Satisfied',
      description:
        'The record(s) highlighted in the table will not be included. They cannot be closed/won because they have open closing requirements that have not been satisfied.',
    },
  },
  reassign: {
    branch: {
      name: 'Records associated with a different branch',
      rowError: 'Record Associated With A Different Branch',
      description:
        'The record(s) highlighted in the table cannot be reassigned to the selected sales team because they are associated with a different branch.',
    },
    crossBranch: {
      name: 'Records associated with a different branch',
      rowError: 'Record Associated With A Different Branch',
      description:
        'The record(s) highlighted in the table cannot be reassigned to the selected sales team because they have services and/or PestPac locations which are associated with a different branch.',
      note: 'Remove the Services for records without PestPac Locations to re-assign the records to any branch.',
    },
    closed: {
      name: 'Closed Records',
      rowError: 'Record Closed',
      description:
        'These record(s) will not be included. They cannot be re-assigned because they are closed. Re-open them to make updates.',
    },
    services: {
      name: 'Records have Services',
      rowError: 'Record has Services',
      description:
        'The record(s) highlighted in the table will not be included. They cannot be re-assigned to a different branch because there are associated Services. Remove Services to make updates.',
    },
    matched: {
      name: 'Records Associated with a Location',
      rowError: 'Record has Location(s)',
      description:
        'The record(s) highlighted in the table will not be included. They cannot be re-assigned to a different branch because they are associated with a Location.',
    },
    open: {
      name: 'Cannot assign inactive user to open record',
      rowError: 'Cannot assign inactive user to open record',
      description:
        'The record(s) highlighted in the table cannot be reassigned to the selected sales team member because open records cannot be assigned to an inactive user.',
      note: 'Close the record or select an active sales team member to re-assign the highlighted record(s)',
    },
  },
  updateExpectedClosingDate: {
    closed: {
      name: 'Closed Records',
      rowError: 'Record Closed',
      description:
        'The record(s) highlighted in the table will not be included. The expected action date cannot be updated because these records are already closed. Re-open them to make updates.',
    },
  },
}

export const bulkErrorColumn: GridColDef = {
  field: '__bulkErrors__',
  headerName: 'Errors',
  renderCell: (params) => <BulkActionErrorCell {...params} />,
  sortable: false,
  width: 230,
}
